import React from "react";

export default function OrderHistoryIcon() {
  return (
    <svg
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.08984 16.3803V2.49538C1.08984 2.03507 1.27246 1.59361 1.59753 1.26812C1.92259 0.942625 2.36347 0.759766 2.82318 0.759766H9.37518C9.82807 0.759822 10.263 0.937369 10.5868 1.25442L14.4348 5.02244C14.5999 5.18406 14.7311 5.3771 14.8207 5.5902C14.9103 5.80331 14.9565 6.03219 14.9565 6.26341V16.3803C14.9565 16.8406 14.7739 17.2821 14.4488 17.6076C14.1238 17.9331 13.6829 18.1159 13.2232 18.1159H2.82318C2.36347 18.1159 1.92259 17.9331 1.59753 17.6076C1.27246 17.2821 1.08984 16.8406 1.08984 16.3803Z"
        stroke="#E0E0E0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.75781 0.759766V4.231C9.75781 4.69131 9.94043 5.13277 10.2655 5.45827C10.5906 5.78376 11.0314 5.96662 11.4911 5.96662H14.9578"
        stroke="#E0E0E0"
        stroke-linejoin="round"
      />
      <path
        d="M4.33984 10.5225H11.9232"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        d="M4.33984 13.7773H8.67318"
        stroke="white"
        stroke-linecap="round"
      />
    </svg>
  );
}
